import React from "react";
import { useTranslation } from "react-i18next";

// State 4 — the full multi-treatment comparison (NOT a single count). Rows come
// from summary.treatments (real seeded data): current policy, domain baseline,
// HiGHS/SCIP, QNNEAL classical and the D-Wave candidate. Infeasible + dry-run-gated
// treatments are shown honestly, never hidden.
export default function SolverComparison({ treatments }) {
  const { t } = useTranslation();
  const rows = treatments || [];
  if (rows.length === 0) return null;
  const statusOf = (tr) => {
    if (tr.state === "dry_run_gated" || tr.objective_value == null) return { key: "gated", tone: "muted" };
    if (tr.feasible === false) return { key: "infeasible", tone: "warn" };
    if (tr.selected) return { key: "selected", tone: "ok" };
    return { key: "feasible", tone: "neutral" };
  };
  const tones = {
    ok: "text-[var(--qn-success)]", warn: "text-[var(--qn-error)]",
    muted: "text-[var(--qn-foreground-subtle)]", neutral: "text-[var(--qn-foreground-muted)]",
  };
  return (
    <div data-testid="solver-comparison">
      <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--qn-foreground-subtle)] font-semibold mb-1">{t("decisionGraph.solver.title")}</div>
      <div className="text-[10px] text-[var(--qn-foreground-subtle)] mb-2">{t("decisionGraph.solver.subtitle")}</div>
      <div className="overflow-hidden rounded-lg border border-[var(--qn-border)]">
        <table className="w-full text-[11px]">
          <thead>
            <tr className="text-[var(--qn-foreground-subtle)] bg-[var(--qn-surface)]">
              <th className="text-left font-medium px-2 py-1.5">{t("decisionGraph.solver.treatment")}</th>
              <th className="text-left font-medium px-2 py-1.5">{t("decisionGraph.solver.engineClass")}</th>
              <th className="text-right font-medium px-2 py-1.5">{t("decisionGraph.solver.objective")}</th>
              <th className="text-right font-medium px-2 py-1.5">{t("decisionGraph.solver.status")}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((tr, i) => {
              const st = statusOf(tr);
              return (
                <tr key={i} data-testid={`solver-row-${tr.name}`} className="border-t border-[var(--qn-border)]">
                  <td className="px-2 py-1.5 text-[var(--qn-foreground)]">{tr.name}</td>
                  <td className="px-2 py-1.5 text-[var(--qn-foreground-muted)]">{tr.engine_class}</td>
                  <td className="px-2 py-1.5 text-right font-mono text-[var(--qn-foreground-muted)]">
                    {tr.objective_value == null ? t("decisionGraph.rail.unavailable") : tr.objective_value}
                  </td>
                  <td className={`px-2 py-1.5 text-right font-medium ${tones[st.tone]}`} data-testid={`solver-status-${tr.name}`}>
                    {t(`decisionGraph.solver.${st.key}`)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
